<template>
	<section>
        <div class="row">
            <div class="qualifier-tool-status-bar">
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">1</div>
                <div class="qualifier-tool-status-number">2</div>
                <div class="qualifier-tool-status-number">3</div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="qualifier-tool-main">
                    <h3>{{model.Step1Title}}</h3>
                    <p class="qualifier-tool-subheader" v-if="model.Step1SubTitle">{{model.Step1SubTitle}}</p>
                </div>
            </div>
        </div>
        <div class="row d-flex justify-content-center qualifier-tool-footer">
            <button type="button" class="qualifier-tool-btn" @click="updateStep(1)">{{model.Step1ForMe}}</button>
            <button type="button" class="qualifier-tool-btn" @click="updateStep(2)">{{model.Step1ForSomeoneElse}}</button>
        </div>
	</section>
</template>

<script>
	import SmoothScroll from 'smooth-scroll';
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['model'],
		data: function () {
			return {
			}
		},
		computed: mapState({
		}),
		components: {
		},
		mounted: function () {	
            if (window.dataLayer != null) {
                window.dataLayer.push({'event': 'Step1'});    
            }
		},
		methods: {
            ...mapActions('WebQualifierTool', { updateStep: 'updateStep' }),            
        },
    }
</script>